export default function BankDetails({ bankDetails }) {
    return (
      <>
    {/* { bankDetails?.bankName && bankDetails?.accountNumber && bankDetails?.accountTitle && bankDetails?.iban && bankDetails?.branchCode ?   */}
      <div className="space-y-4 border border-dashed border-gray-300 p-4 rounded-md">
        <h3 className="text-sm font-medium text-gray-700">Bank Details(Payee)</h3>
  
        <div>
          <label className="block text-sm mb-1">Bank</label>
          <input type="text" value={bankDetails?.bankName} className="w-full p-2 border rounded-md" readOnly />
        </div>
  
        <div>
          <label className="block text-sm mb-1">Account Title</label>
          <input type="text" value={bankDetails?.accountTitle} className="w-full p-2 border rounded-md" readOnly />
        </div>
  
        <div>
          <label className="block text-sm mb-1">Account Number</label>
          <input type="text" value={bankDetails?.accountNumber} className="w-full p-2 border rounded-md" readOnly />
        </div>
  
        <div>
          <label className="block text-sm mb-1">IBAN</label>
          <input type="text" value={bankDetails?.iban} className="w-full p-2 border rounded-md" readOnly />
        </div>
  
        <div>
          <label className="block text-sm mb-1">Branch Code</label>
          <input type="text" value={bankDetails?.branchCode} className="w-full p-2 border rounded-md" readOnly />
        </div>
        </div>

      { !bankDetails && <p className="text-sm text-red-500">No bank details available.</p> }
      </>
    )
  }
  
  